import React, { FC } from 'react';
import styled from 'styled-components';

type RuleSectionErrorsType = {
  attr: string;
  errors: any[];
};

const RuleSectionErrors: FC<RuleSectionErrorsType> = ({ attr, errors = [] }) => {
  const sectionErrors = errors.filter(error => 'attr' in error && error.attr.indexOf(attr) === 0);
  if (!sectionErrors.length) {
    return null;
  }

  return (
    <StyledErrorSection data-aid="ruleSectionErrors">
      {sectionErrors.map(error => {
        return (
          <div data-aid={`ruleSectionErrors-${attr}`} key={error.attr}>
            {error.detail}
          </div>
        );
      })}
    </StyledErrorSection>
  );
};

const StyledErrorSection = styled.div`
  color: ${p => p.theme.colors.red400};
  margin-top: ${p => p.theme.spacing.xsmall};
`;

export default RuleSectionErrors;
